import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_READY = Boolean(BASE);
export const api = axios.create({ baseURL: `${BASE || ""}/api`, withCredentials: true, timeout: 15000 });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
}

export function youtubeId(url = "") {
  const m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/|live\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
}
